import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./axios";
import toastPlugin from "./plugins/toast";
import "./assets/styles.css";

const app = createApp(App);

// Set axios as a global property
app.config.globalProperties.$axios = axios;

// Use plugins
app.use(store);
app.use(router);
app.use(toastPlugin);

// Mount the app
app.mount("#app");
